import React from 'react';
import { AlertTriangle, Check, Eye, DollarSign, Crown } from 'lucide-react';
export function SalesLetter() {
  const scrollToCheckout = () => {
    document.getElementById('checkout')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-16 px-4 bg-brand-black bg-noise" data-id="element-169">
      <div className="max-w-[720px] mx-auto space-y-14" data-id="element-170">
        {/* Apertura Emocional — COMPRIMIDA */}
        <div className="space-y-4" data-id="element-171">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-brand-text leading-tight" data-id="element-172">
            ¿Trabajás más que todos, pero ascendés menos que nadie?
          </h2>
          <p className="text-brand-text font-medium text-xl" data-id="element-173">
            El talento solo no alcanza.
          </p>
          <p className="text-brand-muted text-lg leading-relaxed" data-id="element-174">
            Los que ascienden más rápido no son los más inteligentes — son los
            que saben proyectar autoridad y comunicar valor antes de abrir la
            boca. Y vos seguís esperando que "alguien lo note".
          </p>
        </div>

        {/* Agitación del Dolor — COMPRIMIDA */}
        <div className="space-y-4" data-id="element-175">
          <h3 className="font-heading text-2xl md:text-3xl font-bold text-brand-gold" data-id="element-176">
            Sin el lenguaje del poder:
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-177">
            {['Te pisan en reuniones aunque tengas las mejores ideas', 'Pedís un aumento y te ofrecen "reconocimiento"', 'Colegas menos capaces ascienden antes que vos', 'Nadie te pregunta tu opinión aunque sepas más'].map((item, i) => <div key={i} className="flex items-start bg-brand-dark/50 rounded-lg p-3 border border-brand-red/10" data-id="element-178">
                <AlertTriangle className="text-brand-red mr-2 flex-shrink-0 mt-0.5" size={16} data-id="element-179" />
                <span className="text-brand-text text-sm" data-id="element-180">{item}</span>
              </div>)}
          </div>

          <div className="p-5 border border-brand-gold/50 bg-brand-dark rounded-lg text-center" data-id="element-181">
            <p className="text-brand-text font-medium" data-id="element-182">
              El problema no es tu CV ni tu experiencia.{' '}
              <span className="text-brand-gold" data-id="element-183">
                Es que nadie te enseñó a comunicar poder con tu cuerpo, tu voz y
                tu presencia.
              </span>
            </p>
          </div>
        </div>

        {/* Descubrimiento — COMPRIMIDO */}
        <div className="space-y-4" data-id="element-184">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-brand-text leading-tight" data-id="element-185">
            Existe un lenguaje que los ejecutivos de élite dominan — y ahora
            podés aprenderlo.
          </h2>
          <p className="text-brand-muted text-lg leading-relaxed" data-id="element-186">
            Basado en investigaciones del MIT, Harvard y organismos de
            inteligencia. No es autoayuda — es{' '}
            <span className="text-brand-text font-medium" data-id="element-187">
              neurociencia aplicada al mundo corporativo
            </span>
            , condensada en 6 tomos PDF.
          </p>
        </div>

        {/* 3 Pilares — COMPRIMIDO en fila */}
        <div className="bg-[#2A2311] border-2 border-brand-gold rounded-xl p-6" data-id="element-188">
          <h3 className="font-heading text-xl font-bold text-brand-gold-light text-center mb-6 tracking-wide" data-id="element-189">
            EL SISTEMA — 3 PILARES
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-190">
            <div className="text-center p-4 bg-brand-black/30 rounded-lg" data-id="element-191">
              <Eye className="w-8 h-8 text-brand-gold-light mx-auto mb-2" data-id="element-192" />
              <h4 className="text-brand-gold-light font-bold text-sm mb-1" data-id="element-193">
                LEÉ EL ENTORNO
              </h4>
              <p className="text-brand-text/80 text-xs" data-id="element-194">
                Detectá quién tiene el poder real y leé cada sala antes de
                hablar.
              </p>
            </div>
            <div className="text-center p-4 bg-brand-black/30 rounded-lg" data-id="element-195">
              <DollarSign className="w-8 h-8 text-brand-gold-light mx-auto mb-2" data-id="element-196" />
              <h4 className="text-brand-gold-light font-bold text-sm mb-1" data-id="element-197">
                PROYECTÁ VALOR
              </h4>
              <p className="text-brand-text/80 text-xs" data-id="element-198">
                Usá postura, mirada y voz para que te perciban como
                indispensable.
              </p>
            </div>
            <div className="text-center p-4 bg-brand-black/30 rounded-lg" data-id="element-199">
              <Crown className="w-8 h-8 text-brand-gold-light mx-auto mb-2" data-id="element-200" />
              <h4 className="text-brand-gold-light font-bold text-sm mb-1" data-id="element-201">
                ASCENDÉ CON INTENCIÓN
              </h4>
              <p className="text-brand-text/80 text-xs" data-id="element-202">
                Protocolos concretos para entrevistas, negociaciones y
                reuniones.
              </p>
            </div>
          </div>
        </div>

        {/* Beneficios — COMPRIMIDO en grid didáctico */}
        <div className="space-y-5" data-id="element-203">
          <h3 className="font-heading text-2xl md:text-3xl font-bold text-brand-text text-center" data-id="element-204">
            Con Proyecto Elite vas a poder:
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-205">
            {[{
            icon: '⏱️',
            text: 'Dominar los primeros 7 segundos de cualquier reunión'
          }, {
            icon: '💰',
            text: 'Negociar tu sueldo con postura de valor real'
          }, {
            icon: '🤝',
            text: 'Generar confianza instantánea con directivos'
          }, {
            icon: '🛡️',
            text: 'Neutralizar colegas tóxicos sin confrontar'
          }, {
            icon: '🎤',
            text: 'Presentar con autoridad y sin nervios visibles'
          }, {
            icon: '📊',
            text: 'Medir tu progreso en 90 días con métricas reales'
          }].map((item, i) => <div key={i} className="flex items-center bg-brand-dark border border-brand-gold/20 rounded-lg p-3 gap-3" data-id="element-206">
                <span className="text-xl flex-shrink-0" data-id="element-207">{item.icon}</span>
                <span className="text-brand-text text-sm font-medium" data-id="element-208">
                  {item.text}
                </span>
              </div>)}
          </div>

          <div className="text-center pt-4" data-id="element-209">
            <button onClick={scrollToCheckout} className="px-8 py-4 bg-brand-gold hover:bg-brand-gold-light text-brand-black font-bold text-lg rounded-lg transition-all transform hover:scale-105 animate-pulse-gold shadow-lg" data-id="element-210">
              QUIERO ASCENDER AHORA →
            </button>
          </div>
        </div>
      </div>
    </section>;
}